<template>
  <div class="nav-bar">
    <div class="navbar-points-container mobile-only" v-if="isIframe">
      <div class="navbar-points-balance">
        <img
          src="@/assets/images/reward-points-icon.svg"
          alt="Reward points icon"
        />
        <div>
          <div class="navbar-points-balance-value">
            {{ formattedPoints }} points = R{{ pointsToRands }}
          </div>
        </div>
      </div>
    </div>
    <div class="nav-bar-wrapper">
      <div class="main">
        <a href="https://investectravel.com/home/" class="logo">
          <img
            src="@/assets/images/logos/investec-travel-logo.png"
            alt="Investec travel logo"
            class="logo-img"
          />
        </a>

        <div class="navbar-points-container desktop-only" v-if="isIframe">
          <div class="navbar-points-balance">
            <img
              src="@/assets/images/reward-points-icon.svg"
              alt="Reward points icon"
            />
            <div>
              <div class="navbar-points-balance-value">
                {{ formattedPoints }} points = R{{ pointsToRands }}
              </div>
            </div>
          </div>
        </div>
        <!--MOBILE-->
        <div class="secondary-mobile-menu">
          <div class="secondary-mobile-menu-wrapper">
            <div
              class="secondary-mobile-menu-item"
              v-for="item in menuItems"
              :key="item.name"
            >
              <a :href="item.url" target="_self">{{ item.name }}</a>
            </div>
            <div class="secondary-mobile-menu-item">
              <a
                href="https://www.investectravel.com/contact-us/"
                target="_self"
                >Contact us</a
              >
            </div>
            <a
              href="https://tbi.focusonlinetravel.co.za?logout=1"
              v-if="!isIframe"
            >
              <b-button ref="logout" class="logout-button-mobile">
                <div class="logout-button__inner">Logout</div></b-button
              >
            </a>
          </div>
          <div class="mobile-nav-container mobile-only">
            <div class="mobile-hamburger-menu" @click="toggleMobileMenu">
              <span v-if="!mobileMenuToggled">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
              </span>
              <span v-else class="close-icon">
                <div class="bar close-bar1"></div>
                <div class="bar close-bar2"></div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--DESKTOP-->
      <div class="secondary-desktop-menu">
        <div class="secondary-desktop-menu-wrapper">
          <div class="secondary-desktop-menu-inner">
            <div
              class="secondary-desktop-menu-item"
              :class="{ active: !!item.isActive }"
              v-for="item in menuItems"
              :key="item.name"
            >
              <a :href="item.url" target="_self">{{ item.name }}</a>
            </div>
            <div class="secondary-desktop-menu-item end-item">
              <a
                href="https://www.investectravel.com/contact-us/"
                target="_self"
                >Contact us</a
              >
              <div
                v-if="!isIframe"
                style="width: 2px; background: #d4d3cea3; margin: 0 30px; height: 20px;"
              ></div>
              <a href="https://www.investectravel.com?logout=1" v-if="!isIframe">
                <b-button
                  ref="logout"
                  
                  class="logout-button"
                >
                  <div class="logout-button__inner">Log out</div></b-button
                >
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { mapActions, mapState } from "vuex";
//import NavMobile from '~/components/Navigation/NavMobile.vue'
//import types from "~/constants/actions";
gsap.registerPlugin(ScrollTrigger);
export default {
  components: {
    // NavMobile,
  },
  props: {
    pinned: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuItems: [
        { name: "Home", url: "https://www.investectravel.com/" },
        {
          name: "Flights, cars, hotels",
          url: "https://www.investectravel.com/flights-cars-hotels/",
          isActive: true
        },
        { name: "Curated holidays", url: "https://www.investectravel.com/packages/" },
        {
          name: "Signature Journeys",
          url: "https://www.investectravel.com/signature-journeys/"
        },
        { name: "Partners", url: "https://www.investectravel.com/partners/" },
        { name: "Insurance", url: "https://www.investectravel.com/insurance/" }
      ],
      mobileMenuToggled: false
    };
  },
  computed: {
    ...mapState({
      loggedIn: state => state.login,
      mobileMenuActive: false, // state => state.mobile.mobileMenuActive || false
      isIframe: state => state.isIframe,
      points: state => state.points
    }),
    pointsValue() {
      // if (this.points == undefined || isNaN(this.points)) {
      //   return 0;
      // }
      return (this.points / 20)
        .toFixed(2)
        .toString()
        .replace(/,/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formattedPoints() {
      // if (this.points == undefined || isNaN(this.points)) {
      //   return 0;
      // }
      return Math.floor(this.points)
        .toString()
        .replace(/,/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    pointsToRands() {
      // if (this.points == undefined || isNaN(this.points)) {
      //   return 0;
      // }
      return (this.points / 20)
        .toString()
        .replace(/,/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    dontShowPoints() {
      return (
        this.points == undefined ||
        isNaN(this.points) ||
        this.points == 0 ||
        isNaN(this.pointsValue) ||
        this.pointsValue == 0 ||
        isNaN(this.formattedPoints) ||
        this.formattedPoints == 0 ||
        isNaN(this.pointsToRands) ||
        this.pointsToRands == 0
      );
    }
  },
  mounted() {
    this.initAnimations();
    if (
      (window !== window.parent || this.isIframe) &&
      (this.points == undefined || isNaN(this.points))
    ) {
      this.$store.dispatch("initializeInvsy");
    }
  },
  methods: {
    bookACar() {
      // link to external
    },
    bookAFlight() {
      // link to external
    },
    showMobileMenu() {
      this.mobileMenuActive = true;
    },
    toggleMobileMenu() {
      const menu = document.querySelector(".secondary-mobile-menu-wrapper");
      if (menu.style.display === "none" || menu.style.display === "") {
        menu.style.display = "flex";
      } else {
        menu.style.display = "none";
      }
      this.mobileMenuToggled = !this.mobileMenuToggled;
    },
    // ...mapActions('auth', [types.SHOW_LOGIN_MODAL, types.LOGOUT]),
    // ...mapActions('mobile', [types.SHOW_MOBILE_MENU]),
    initAnimations() {
      if (this.pinned) {
        if (!this.loggedIn) {
          // fix it to the top as it will always overlay
          gsap.set(".nav-bar", { position: "fixed" });
          gsap.to(".nav-bar", {
            duration: 0.25,
            ease: "power1.inOut",
            background: "rgba(255,255,255,1)",
            paddingTop: 25,
            paddingBottom: 25,
            scrollTrigger: {
              toggleActions: "play none none reverse",
              trigger: "body",
              start: "top -20px"
            }
          });
        } else {
          gsap.to(".nav-bar", {
            duration: 0.25,
            ease: "power1.inOut",
            paddingTop: 25,
            paddingBottom: 25,
            scrollTrigger: {
              toggleActions: "play none none reverse",
              trigger: "body",
              start: "top -20px"
            }
          });

          gsap.to(".nav-bar", {
            scrollTrigger: {
              pin: ".nav-bar",
              pinSpacing: false,
              trigger: "body",
              start: "top 0px"
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/settings.scss";
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap"); /* Import the Inter font with weight 500 from Google Fonts */

.logout-button {
  color: #30384a;
  background-color: white;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.3;
  position: relative;
  letter-spacing: 0.16px;
  padding: 8px 15px;
  border-radius: 50px;
  border: none !important;
  height: 36.79px;
}

.logout-button-mobile {
  margin-top: 16px;
  color: white;
  background: #30384a;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.3;
  position: relative;
  letter-spacing: 0.16px;
  padding: 8px 15px;
  border-radius: 50px;
  border: none !important;
  height: 36.79px;
  .logout-button__inner {
    font-weight: 500;
  }
}

.logout-button__inner {
  padding-left: 20px;
  padding-right: 20px;
  font-weight: 500;
}

.nav-bar-wrapper {
  max-width: 1380px;
  margin: auto;
  display: flex;
  flex-direction: column; // Stack items vertically
  align-items: center;
  width: 100%;
}

.main,
.secondary-desktop-menu {
  width: 100%;
}

.navbar-points-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 5px;
  padding-right: 30px;
  .navbar-points-balance {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    height: 100%;
    img {
      max-height: 32px;
      opacity: 0.8;
      margin-right: 20px;
    }
    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      .navbar-points-balance-heading {
        font-size: 12px;
        font-weight: 800;
        color: #00204e;
      }
      .navbar-points-balance-value {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .navbar-points-divider {
    height: 60%;
    width: 1px;
    background: #00204e;
  }
  .navbar-points-value {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .navbar-points-value-heading {
      font-size: 12px;
      font-weight: 800;
      color: #00204e;
    }
    .navbar-points-value-value {
      font-size: 12px;
      font-weight: 500;
    }
  }
}

.secondary-desktop-menu-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  width: 100%;
  max-width: 100%;
  padding-left: 20px;
}

.secondary-desktop-menu-inner {
  display: flex;
  justify-content: center;
  align-items: baseline;
  width: 100%;
}

.secondary-desktop-menu-item {
  height: 40px;
  padding: 20px;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.secondary-desktop-menu-item:first-child {
  padding-left: 0;
}

.secondary-desktop-menu-item:not(:last-child) {
  margin-right: 15px;
}

.secondary-desktop-menu-item.active {
  position: relative;

  border-bottom: 2px solid #30384a;

  // &::after {
  //   content: '';
  //   position: absolute;
  //   bottom: -5px;
  //   left: 50%;
  //   transform: translateX(-45%);
  //   width: 125%;
  //   height: 2px;
  //   background-color: #30384A;
  // }
}

.secondary-desktop-menu-item:last-child {
  margin-right: 0;
}

.secondary-desktop-menu-item a {
  text-decoration: none;
  color: #30384a;
  transition: color 0.3s ease;

  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
}
.end-item {
  display: flex;
  align-items: center;
}

.secondary-mobile-menu {
  display: none;
}

.mobile-nav-container {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 $edgeLarge 10px $edgeLarge;
  text-align: right;
}

.mobile-hamburger-menu {
  cursor: pointer;
}

.bar {
  width: 20px;
  height: 2px;
  background-color: #30384a;
  margin-bottom: 5px;
  display: block;
}

.bar:last-child {
  margin-bottom: 0;
}

.close-icon {
  position: relative;
}

.close-bar1,
.close-bar2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center;
  width: 20px;
  height: 2px;
  background-color: #30384a;
}

.close-bar1 {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close-bar2 {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.secondary-mobile-menu-wrapper {
  position: absolute;
  top: 80%;
  left: 0;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  text-align: left;
  display: none; /* Hides by default */
  background: #ecece9;
  box-shadow: 0px 4px 8px -2px #00000014;
  padding: 0 $edgeLarge 24px $edgeLarge;
}

.secondary-mobile-menu-item a {
  text-decoration: none;
  color: #30384a;
  transition: color 0.3s ease;
  text-decoration: underline;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1%;
}

// Custom breakpoint for secondary desktop menu
@media (min-width: 781px) and (max-width: 1032px) {
  .secondary-desktop-menu-item a {
    font-size: 14px;
  }
}

// Toggle secondary desktop menu
@media (max-width: 1254px) {
  .nav-bar {
    box-shadow: 0px 3px 8px 0px #00000014;
  }
  .secondary-desktop-menu {
    display: none !important;
    flex-wrap: wrap;
    div {
      flex-wrap: wrap;
    }
  }
  .secondary-mobile-menu {
    display: block;
  }
  .mobile-nav-container,
  .secondary-mobile-menu-wrapper {
    padding-left: 24px;
    padding-right: 20px;
    padding-top: 10px;
  }
}

@media (max-width: 781px) {
  .logo-img {
    width: 150px !important;
  }
  .navbar-points-container {
    width: 100%;
    justify-content: center;
  }
}

.logo-img {
  width: 190px;
}

.link-active {
  border-bottom: 2px solid #00204e !important;
}

.nav-bar {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 12;
  background: #ecece9;

  .main {
    padding: 24px $edgeLarge;
    padding-top: 18px;
    padding-right: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;

    .mobile-hamburger {
      display: none;
    }
  }
  .logo {
    font-style: normal;
    font-weight: 300;
    font-size: 3px;
    line-height: 28px;
    color: $navy;
    text-decoration: none;
    cursor: pointer;
    .bold {
      font-weight: bold;
    }
  }

  .nav-items {
    display: inline-block;
    margin-right: 0;
    margin-left: auto;
    .item {
      display: inline-block;
      margin-left: 80px;

      cursor: pointer;
      .icon-phone,
      .icon-mail {
        font-size: 20px;
        margin-right: 20px;
        color: $navy;
      }

      a {
        font-family: "Inter";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        /* identical to box height, or 150% */

        display: flex;
        align-items: center;
        letter-spacing: 0.5px;

        color: #000000;
      }

      .login {
        color: $navy;
        text-decoration: none;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 150%;
        display: flex;
        align-items: center;
        text-align: center;
      }
    }
  }

  @media (max-width: 1160px) {
    .nav-items {
      .item {
        margin-left: 30px;
      }
    }
  }

  @media (max-width: 1013px) {
    .main {
      justify-content: space-between;
      align-items: center;
      .nav-items {
        display: none;
      }
      .mobile-hamburger {
        display: block;
        cursor: pointer;
      }
    }
  }

  @media (max-width: 1254px) {
    .main {
      padding-left: 22px;
      padding-right: 22px;
      .link-wrapper {
        margin-left: 0;
      }
    }
  }

  @media (max-width: 500px) {
    .logo {
      font-size: 20px;
    }
  }
}
</style>
